(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-newsletter"] && !Shopify.designMode) return;
  try {
    
  function loadMangalitsaNewsletter(root) {
    if (!root || root.dataset.loaded) return;
    root.dataset.loaded = 'true';
    const status = root.querySelector('[data-issue-status]');
    const frame = root.querySelector('[data-issue-frame]');
    fetch('https://entre-api.forgetrajectory.com/v1/public/newsletter/latest', { credentials: 'omit', signal: AbortSignal.timeout(15000) })
      .then(response => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
      .then(issue => {
        if (!issue.html) throw new Error('No issue');
        root.querySelector('[data-issue-title]').textContent = issue.title || 'Latest newsletter';
        const date = new Date(issue.published_at);
        root.querySelector('[data-issue-date]').textContent = issue.published_at && !isNaN(date) ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : '';
        status.textContent = issue.stale ? 'Showing the most recently saved issue. Check the issue date and offer dates before ordering.' : '';
        status.hidden = !issue.stale;
        frame.addEventListener('load', () => {
          const doc = frame.contentDocument;
          if (!doc) return;
          const resize = () => { frame.style.height = Math.max(500, doc.documentElement.scrollHeight, doc.body?.scrollHeight || 0) + 'px'; };
          doc.addEventListener('click', event => {
            const link = event.target.closest('a');
            if (!link) return;
            const href = link.getAttribute('href') || '';
            if (href.startsWith('#')) return;
            event.preventDefault();
            if (/^\/(?!\/)/.test(href) || /^(mailto:|tel:)/.test(href)) window.location.assign(href);
          });
          doc.querySelectorAll('img').forEach(img => img.addEventListener('load', resize));
          resize();
          const observer = new ResizeObserver(resize);
          if (doc.body) observer.observe(doc.body);
        }, { once: true });
        frame.hidden = false;
        const forwardedPrelude = issue.title?.startsWith('FWD:') ? '#mceColumnId--9{display:none!important}' : '';
        frame.srcdoc = '<meta http-equiv="Content-Security-Policy" content="default-src &#39;none&#39;; img-src https://mcusercontent.com https://gallery.mailchimp.com https://us13.campaign-archive.com; style-src &#39;unsafe-inline&#39;; font-src &#39;none&#39;; base-uri &#39;none&#39;; form-action &#39;none&#39;"><meta name="viewport" content="width=device-width,initial-scale=1">' + issue.html + '<style>html,body{margin:0!important;padding:0!important;min-width:0!important;background:#fff!important}img{max-width:100%!important;height:auto!important}table{max-width:100%!important}body{overflow-wrap:anywhere}a{cursor:pointer}' + forwardedPrelude + '@media(max-width:600px){table,td{min-width:0!important}table{width:100%!important}}</style>';
      })
      .catch(() => { status.hidden = false; status.textContent = 'The latest issue is temporarily unavailable. Please try again shortly, or browse our pork above.'; });
  }
  document.querySelectorAll('[data-me-newsletter]').forEach(loadMangalitsaNewsletter);
  document.addEventListener('shopify:section:load', event => loadMangalitsaNewsletter(event.target.querySelector('[data-me-newsletter]')));

  } catch(e) { console.error(e); }
})();
})();
